const getFormLabelRangeCaption = (prefix = "", suffix = "", percentage = false, input) => {
  const { value = "" } = input;
  const valueString = `${prefix}${value}${suffix}`;
  const percentageString = percentage ? ` (${getRangeValueAsPercentage(input)})` : "";
  return `${valueString}${percentageString}`;
};
const getRangeValueAsPercentage = (input, places) => {
  const { max: rawMax = "", min: rawMin = "", value: rawValue = "" } = input;
  const min = rawMin === "" ? 0 : parseFloat(rawMin);
  const max = rawMax === "" ? 100 : parseFloat(rawMax);
  const value = rawValue === "" ? 50 : parseFloat(rawValue);
  const parsedPlaces = places ? places : 2;
  const number = parseFloat(((value - min) * 100 / (max - min)).toFixed(parsedPlaces));
  return isNaN(number) ? "0%" : `${number}%`;
};
function getRangeValues(input) {
  let min = input.min || input.getAttribute("aria-valuemin") || input.getAttribute("min");
  let max = input.max || input.getAttribute("aria-valuemax") || input.getAttribute("max");
  let value = input.value || input.getAttribute("aria-valuenow") || input.getAttribute("value");
  if (!min || min === "")
    min = "0";
  if (!max || max === "")
    max = "100";
  if (!value || value === "")
    value = "50";
  const newMin = parseFloat(min);
  const newMax = parseFloat(max);
  const newValue = parseFloat(value);
  let dec = (newValue - newMin) / (newMax - newMin);
  if (isNaN(dec))
    dec = 0;
  return {
    dec,
    max: newMax,
    min: newMin,
    value: newValue
  };
}
function updateRangeSliderHTMLState(input) {
  const parent = input.closest(".tds-form-item");
  const caption = parent && parent.querySelector(".tds-form-caption");
  const { dec, max, min, value } = getRangeValues(input);
  const percent = (100 * dec).toFixed(2);
  input.style.setProperty("--tds-form-input-range--progress-width", `${percent}%`);
  if (caption) {
    const { tdsPercentage, tdsPrefix, tdsSuffix } = caption.dataset || {};
    caption.textContent = getFormLabelRangeCaption(
      tdsPrefix,
      tdsSuffix,
      Boolean(tdsPercentage),
      input
    );
  }
  input.value = `${value}`;
  input.min = `${min}`;
  input.max = `${max}`;
  input.setAttribute("value", `${value}`);
  input.setAttribute("aria-valuenow", `${value}`);
  input.setAttribute("aria-valuemin", `${min}`);
  input.setAttribute("aria-valuemax", `${max}`);
}
const initRangeInput = (component, props = {}) => {
  const { beta, onChange } = props;
  if (beta) {
    updateRangeSliderHTMLState(component);
    component.addEventListener("change", (e) => {
      updateRangeSliderHTMLState(e.currentTarget);
    });
    component.addEventListener("input", (e) => {
      updateRangeSliderHTMLState(e.currentTarget);
    });
  } else {
    const parent = component.closest(".tds-form-item");
    const caption = parent && parent.querySelector(".tds-form-label .tds-form-caption");
    const { tdsPercentage, tdsPrefix, tdsSuffix } = caption?.dataset || {};
    const updateProgressState = () => {
      const newPercent = getRangeValueAsPercentage(component);
      component.setAttribute("aria-valuenow", component.value);
      if (component.getAttribute("min") !== component.min) {
        component.setAttribute("aria-valuemin", component.min);
      }
      if (component.getAttribute("max") !== component.max) {
        component.setAttribute("aria-valuemax", component.max);
      }
      component.style.setProperty("--tds-form-input-range--progress-width", newPercent);
      if (caption)
        caption.innerText = getFormLabelRangeCaption(
          tdsPrefix,
          tdsSuffix,
          Boolean(tdsPercentage),
          component
        );
    };
    updateProgressState();
    component.addEventListener("change", (e) => {
      updateProgressState();
      if (onChange)
        onChange(e);
    });
    component.addEventListener("input", (e) => {
      updateProgressState();
      if (onChange)
        onChange(e);
    });
  }
  return component;
};
const initRangeInputs = (props = {}) => {
  const { parent = document } = props;
  const inputs = Array.from(parent.querySelectorAll(".tds-form-input-range"));
  inputs.forEach((component) => {
    initRangeInput(component, props);
  });
};
export {
  getFormLabelRangeCaption,
  getRangeValueAsPercentage,
  getRangeValues,
  initRangeInput,
  initRangeInputs,
  updateRangeSliderHTMLState
};
